import type { TokenStore } from '../apiClient';

export interface SessionTokens {
  accessToken: string;
  refreshToken: string;
  /** Seconds until the access token expires. */
  expiresIn: number;
}

export interface SessionStore {
  /** Bearer source for the authed apiClient (access token, memory-only). */
  accessStore: TokenStore;
  getRefresh(): string | null;
  setSession(tokens: SessionTokens): void;
  clear(): void;
}

const REFRESH_KEY = 'la.advisor.refresh';

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function defaultStorage(): StorageLike | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null; // localStorage can throw in sandboxed iframes
  }
}

export function createSessionStore(storage: StorageLike | null = defaultStorage()): SessionStore {
  let access: string | null = null;
  return {
    accessStore: {
      get: () => access,
      set: (t) => { access = t; },
    },
    getRefresh: () => storage?.getItem(REFRESH_KEY) ?? null,
    setSession: (tokens) => {
      access = tokens.accessToken;
      try {
        storage?.setItem(REFRESH_KEY, tokens.refreshToken);
      } catch {
        // persistence unavailable (e.g. Safari private mode); session still works in-memory
      }
    },
    clear: () => {
      access = null;
      try {
        storage?.removeItem(REFRESH_KEY);
      } catch {
        // ignore
      }
    },
  };
}
